import type { SelectedFilters } from '@/hooks/filters/useCompanyAttributesFilters';
import type { CompanyAttributeMap } from '@/utils/company';

import { Filters } from '@/constants/Filters';

interface GetAttributeEntriesWithSelectedValuesParams {
    selectedCompanyAttributes?: CompanyAttributeMap;
    filters: SelectedFilters;
}

const STANDARD_KEYS: string[] = [
    Filters.DEPARTMENTS,
    Filters.EMPLOYEE_LEVELS,
    Filters.JOB_TITLES,
    Filters.COMPANY_ADDRESSES,
    Filters.MANAGERS,
];

export const getAttributeEntriesWithSelectedValues = ({
    selectedCompanyAttributes,
    filters,
}: GetAttributeEntriesWithSelectedValuesParams) =>
    Object.entries(selectedCompanyAttributes ?? {}).map(([key, attribute]) => {
        const isCustomAttribute = !STANDARD_KEYS.includes(key);

        const filterKey = isCustomAttribute ? 'customAttributes' : key;

        const selectedValues = (filters[filterKey] ?? [])
            .map((v) => v.id)
            .filter((id): id is string => !!id);

        return { attribute, selectedValues };
    });
